import { createContext, useContext, useState, useMemo } from 'react';

const TenantContext = createContext(null);

export const TenantProvider = ({ children }) => {
  const [selectedTenant, setSelectedTenant] = useState(null);

  const value = useMemo(
    () => ({
      selectedTenant,
      setSelectedTenant
    }),
    [selectedTenant]
  );

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  );
};

export const useSelectedTenant = () => useContext(TenantContext);
